import styled from 'styled-components';

import { borderRadius } from '@/theme/selectors';

export const Container = styled.ul`
    display: flex;
    flex-direction: column;
    padding: 16px;
    background-color: ${({ theme }) => theme['surface-hovered']};
    border-radius: ${borderRadius('medium')};
    margin-top: 8px;
    gap: 8px;
`;

export const Item = styled.li`
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
        content: '';
        flex-shrink: 0;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #2e7d32;
    }

    & > *:last-child {
        margin-left: auto;
    }

    p:first-letter {
        text-transform: uppercase;
    }
`;

export const Section = styled.section`
    margin-top: 32px;
`;
